﻿// Use jsdelivr for browser-ready JS file
//import emailSpellChecker from 'https://cdn.jsdelivr.net/npm/@zootools/email-spell-checker/+esm';
//import distance from 'https://cdn.jsdelivr.net/npm/@zootools/email-spell-checker@1.12.0/dist/lib/helpers/sift3Distance.js/+esm';
import emailSpellChecker from './email-spell-checker-esm/index.js';
import distance from './email-spell-checker-esm/helpers/sift3Distance.js';
(function () {
    const emailInput = document.getElementById('EmailAddress');
    const warningContainer = document.getElementById('email-warning-container');
    const warningEle = document.getElementById('warning');
    const warningText = document.getElementById('warning-text');
    const warningEmail = document.getElementById('warning-email');
    const warningDismiss = document.getElementById('warning-dismiss');
    const additionalDomains = [
        "ntlworld.com",
        "virginmedia.com",
        "talk21.com",
        "btconnect.com",
        "btopenworld.com"
    ]

    // Timer for debouncing suggestedEmail updates
    let debounceTimer;

    // Takes a callback and a time argument, clears `debounceTimer` if exists, and returns the new timer
    const debounce = (callback, time) => {
        if (debounceTimer) window.clearTimeout(debounceTimer);
        debounceTimer = window.setTimeout(callback, time);
    };

    emailInput.addEventListener('keyup', () => {
        debounce(() => {
            const email = emailInput.value;

            const mailcheckDistance = (domain, knownDomain) => {
                let dist = distance.default(domain, knownDomain)
                // force prioritize .com matches over .co and .ca
                if (knownDomain === 'com') dist -= 0.75
                return dist
            }

            // Get suggested email
            const suggestedEmail = emailSpellChecker.run({
                email,
                domains: [...emailSpellChecker.POPULAR_DOMAINS, ...additionalDomains],
                distanceFunction: mailcheckDistance
            });

            // If return value exists
            if (suggestedEmail) {
                // Make the warning container visible,
                warningContainer.classList.add('view');

                // and add warning text
                warningText.innerText = `Did you mean`;
                warningEmail.innerText = `${suggestedEmail.full}?`;
            } else {
                // Else, hide the warning container
                warningContainer.classList.remove('view');
            }
        }, 400);
    });

    // Hide the modal when the dismiss button is clicked
    warningDismiss.addEventListener('click', e => {
        e.preventDefault();
        warningContainer.classList.remove('view');
    });

    warningEle.addEventListener('click', e => {
        e.preventDefault();
        // Remove question mark at the end of the warning message's email part
        const parsedWarningEmail = warningEmail.innerText.slice(0, -1);
        emailInput.value = parsedWarningEmail;

        warningContainer.classList.remove('view');

        if (cac_data && cac_data.form && cac_data.form.validator) {
            cac_data.form.validator.isFieldValid(emailInput);
        }
    });

    warningContainer.classList.remove('hidden');
})();